import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Table, Tag } from 'antd';
import dayjs from 'dayjs';

function index({ orders, total, handleTableChange, loading = false, query = {}, onSelect = () => {} }) {
    useEffect(() => {
        // console.log(orders);
        return () => {};
    }, [orders]);

    const columns = [
        {
            title: 'Ref',
            key: 'ref',
            render: (text, record) => (
                <div>
                    <div>{record.ref}</div>
                    <div>
                        {record.status && (
                            <Tag color={record.status === 'Cancelled' ? 'red' : 'blue'}>{record.status}</Tag>
                        )}
                    </div>
                </div>
            ),
        },
        {
            title: '用车时间',
            key: 'datetime',
            render: (text, record) => (
                <div>
                    <div>{dayjs(record.time).format('YYYY-MM-DD HH:mm')}</div>
                    {record.retTime && <div>返程{dayjs(record.retTime).format('YYYY-MM-DD HH:mm')}</div>}
                </div>
            ),
        },
        {
            title: '起点',
            key: 'from',
            render: (text, record) => (
                <div>
                    <div>{record.pickupName}</div>
                    <div>{record.pickupAddress}</div>
                </div>
            ),
        },
        {
            title: '终点',
            key: 'to',
            render: (text, record) => (
                <div>
                    <div>{record.dropoffName}</div>
                    <div>{record.dropoffAddress}</div>
                </div>
            ),
        },
        {
            title: '金额',
            key: 'amount',
            render: (text, record) => (
                <div style={{ whiteSpace: 'nowrap' }}>
                    {record.currency}
                    {record.saleTotalPrice}
                </div>
            ),
        },
        {
            title: '乘客',
            key: 'passenger',
            render: (text, record) => (
                <div>
                    <span style={{ whiteSpace: 'nowrap' }}>
                        {record.passenger.firstName} {record.passenger.lastName}
                    </span>
                    {record.passenger.passengerCount && <span>({record.passenger.passengerCount})</span>}
                </div>
            ),
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button type="link" size="small" onClick={() => onSelect(record)}>
                        查看
                    </Button>
                );
            },
        },
    ];

    return (
        <div>
            <Table
                dataSource={orders}
                rowKey={'id'}
                columns={columns}
                onChange={handleTableChange}
                loading={loading}
                pagination={{
                    current: query.page,
                    pageSize: query.pageSize,
                    total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (num) => `Total ${num} items`,
                    pageSizeOptions: [1, 10, 20, 50, 100],
                }}
            />
        </div>
    );
}

index.propTypes = {
    orders: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    handleTableChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    query: PropTypes.object,
    onSelect: PropTypes.func.isRequired,
};

export default index;
